import React from 'react';
import PropTypes from 'prop-types';

import 'src/components/EmptyListing/ListingImage.scss';


const ListingImage = function ({ desktop, mobile }) {
  return (
    <>
      <img alt="" aria-hidden="true" src={ mobile } styleName="listing-image" width="316" height="220"/>
      <img
        alt=""
        aria-hidden="true"
        src={ desktop }
        styleName="listing-image listing-image--desktop"
      />
    </>
  );
};

ListingImage.propTypes = {
  desktop: PropTypes.string.isRequired,
  mobile: PropTypes.string.isRequired
};

export default ListingImage;
